<template>
  <div class="app-logo">
    <img :src="getLogoPath" />
  </div>
</template>
<script lang="js">
export default {
  name: "AppLogo",
  computed: {
    getLogoPath() {
      return `/img/logo.png`;
    }
  }
}
</script>
<style lang="scss">
.app-logo {
  img {
    width: inherit;
  }
}
</style>
